import React from "react"

import StoryblokBasicImage from "../../internal/storyblokBasicImage/StoryblokBasicImage"

import * as styles from "./ImageTextPanel.module.scss"
import { resolveRichTextWithComponents } from "../../../utils/richText"
import { BackgroundKeyToColor, GeneralSizeKeyToPaddingNumber } from "../../../utils/datasources"

function ImageTextPanel({ blok }) {
  const contentBackgroundColor = BackgroundKeyToColor(blok.content_background_color),
        barTopColor = BackgroundKeyToColor(blok.bar_top_color),
        barBottomColor = BackgroundKeyToColor(blok.bar_bottom_color),
        barTopPadding = GeneralSizeKeyToPaddingNumber(blok.bar_top_height),
        barBottomPadding = GeneralSizeKeyToPaddingNumber(blok.bar_bottom_height)

  return (
    <section style={{ backgroundColor: contentBackgroundColor }} className={blok.image_side === "left" ? styles.imageLeft : null}>
      {blok.bar_top_color ? <div style={{ backgroundColor: barTopColor, height: barTopPadding }} /> : null}
      <div className={`content-limits ${styles.wrapper}`}>
        <div className={styles.content}>
          {resolveRichTextWithComponents(blok.text)}
        </div>
        <div className={styles.image} style={{marginTop: -barTopPadding, marginBottom: -barBottomPadding}}>
          {blok.image ? <StoryblokBasicImage image={blok.image} /> : null}
        </div>
      </div>
      {blok.bar_bottom_color ? <div style={{ backgroundColor: barBottomColor, height: barBottomPadding }} /> : null}
    </section>
  )
}

export default ImageTextPanel